export const FOOTWEAR_PATH_SEPARATOR = ' > ';

export const FOOTWEAR_CATEGORY_TREE = {
  Men: [
    'Sneakers',
    'Casual Shoes',
    'Dress Shoes',
    'Boots',
    'Sandals',
    'Slippers',
    'Loafers & Moccasins',
    'Athletic Shoes',
    'Work & Safety Shoes',
    'Hiking & Outdoor Shoes',
    'Water Shoes',
    'Footwear Accessories',
  ],
  Women: [
    'Sneakers',
    'Flats',
    'Heels',
    'Sandals',
    'Boots',
    'Loafers & Moccasins',
    'Wedges',
    'Espadrilles',
    'Mules & Clogs',
    'Athletic Shoes',
    'Slippers',
    'Water Shoes',
    'Footwear Accessories',
  ],
  Kids: [
    'Sneakers',
    'School Shoes',
    'Sandals',
    'Boots',
    'Slippers',
    'Athletic Shoes',
    'Water Shoes',
    'First Walker Shoes (Babies & Toddlers)',
    'Character Shoes',
    'Footwear Accessories',
  ],
};

export const FOOTWEAR_DEPARTMENTS = Object.keys(FOOTWEAR_CATEGORY_TREE);

export function isFootwearListingCategory(category) {
  return category === 'Footwear';
}

export function joinFootwearSubcategoryPath(parts) {
  return parts.filter(Boolean).join(FOOTWEAR_PATH_SEPARATOR);
}

export function parseFootwearSubcategoryPath(value) {
  if (!value) {
    return { department: '', subcategory: '' };
  }
  const [department = '', subcategory = ''] = String(value).split(FOOTWEAR_PATH_SEPARATOR);
  return { department, subcategory };
}

export function getFootwearSubcategories(department) {
  return FOOTWEAR_CATEGORY_TREE[department] || [];
}

export function getFootwearDepartmentsForBrowse() {
  return FOOTWEAR_DEPARTMENTS;
}
